<template>
    <div class="birthday">
        <slick
            ref="slick"
            :options="slickOptions"
          >
                <birthday-item :key="index" v-for="(birthday,index) in birthdays" :image="birthday.image" :name="birthday.name"></birthday-item>
            </slick>

    </div>
</template>
<script>

import Slick from 'vue-slick';
import BirthdayItem from '@/components/Birthday/BirthdayItem'
export default {
    components: {Slick, BirthdayItem},
    name: 'Birthday',
    data(){
        return {
            slickOptions: {
                slidesToShow: 3,
                autoplay:true,
                autoplaySpeed:2000,
                arrows:false
            },
        }
    
    },
    props: ['birthdays']
}
</script>
<style>
.birthday{
    padding-top: 80px;
    padding-bottom: 80px;
    min-height: 300px;
    background: url(../assets/birthday3.png);
    background-size: 100% 100%;
}
slick{
    margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/Birthday.vue